export default __webpack_public_path__ + "static/media/mol.4bdd5e85.svg";